import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";
import { formatDate } from "../../helpers/DateConversion";

export default function ViewPricing() {

  const [data, setData] = useState([]);
  const [subCatg, setSubCatg] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [loading, setLoading] = useState(false);

  const { id, CategoryName } = useParams();
  const navigate = useNavigate(null);

  useEffect(() => {
    getProducts();
    getSubCategories();
    getAccessories();
  }, [id]);

  // Fetching Data
  const getProducts = async () => {
    setLoading(true);
    console.log("get Prodcut Called");
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/product/by-category?searchId=${id}`,
        {
          headers: headers,
        }
      );

      console.log("Response", response);
        setData(response.data.result);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getSubCategories = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/subCategory/by-categoryId/${id}`,
        {
          headers: headers,
        }
      );
      if (response.data.statusCode === 200) {
        console.log("Response", response);
        setSubCatg(response.data.result.subCategories);
      } else {
        // toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getAccessories = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const formdata = new FormData();
      formdata.append("categoryId", id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/accessory/get-accessories-by-category`,
        formdata,
        {
          headers: headers,
        }
      );
      console.log("Response", response);
      setAccessories(response?.data?.result?.accessories);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const deleteSubCategory = async (id) => {
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("subCategoryId", id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/subCategory/delete-subCategory`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
        getSubCategories();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to edit sub category. Please try again.", error);
    }
  };

  const deleteProduct = async (id) => {
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("productId", id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/product/delete-product`,
        formdata,
        { headers }
      );
      console.log("Prodcuts Response delete", response);
      await getProducts();
      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete product. Please try again.", error);
    }
  };

  const deleteAccessory = async (id) => {
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("accessoryId", id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/accessory/delete-accessory`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
        getAccessories();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to edit accessory. Please try again.", error);
    }
  };

  return (
    <div>
      <Layout>
        <ToastContainer />
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          {/* <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Category</h2>
          </div> */}
       
          {/* Sub Category */}

           {["laundry"].includes(CategoryName?.toLowerCase()) && (

          <div>
            <div className="flex justify-between items-center mt-0">
              <h2 className="text-lg font-medium">View Sub Categories</h2>
              <div className="">
                <button
                  className="border py-2 px-2 rounded-md text-sm !outline-none"
                  onClick={() => {
                    navigate(`/admin-panel/sub-category/add/${id}`);
                  }}
                >
                  Add Sub Category
                </button>
              </div>
            </div>

            {/* Sub Catg Listing */}
            <div className="mt-6">
              <div className="flex gap-4 justify-between flex-wrap mt-5">
                <table className="w-full text-center">
                  <thead>
                    <tr className="border-b">
                      <td className="font-medium py-4 cursor-pointer">
                        Product Name{" "}
                      </td>
                      <td className="font-medium py-4 cursor-pointer">
                        Created At{" "}
                      </td>
                      <td className="font-medium py-4 cursor-pointer">
                        Status{" "}
                      </td>
                      <td className="font-medium py-4 cursor-pointer">
                        Actions{" "}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {!loading ? (
                      subCatg?.length > 0 ? (
                        subCatg?.map((item) => (
                          <tr key={item._id} className="border-b">
                            <td className="py-3 text-sm">{item.name}</td>
                            <td className="py-3 text-sm">
                              {formatDate(item.createdAt)}
                            </td>
                            <td className="py-3 text-sm">{item.status}</td>
                            <td className="py-3 text-sm flex justify-center gap-x-3">
                              <button
                                className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                                title="View Sub Category"
                                onClick={() => {
                                  navigate(
                                    `/admin-panel/sub-category/view/${item._id}`,
                                    { state: { data: item } }
                                  );
                                }}
                              >
                                <i className="fa fa-eye text-white"></i>
                              </button>
                              <button
                                className="h-[36px] w-[36px] bg-[#ff8a00] rounded-full"
                                title="Edit Sub Category"
                                onClick={() => {
                                  navigate(
                                    `/admin-panel/sub-category/edit/${item._id}`,
                                    { state: { data: item } }
                                  );
                                }}
                              >
                                <i className="fa fa-edit text-white"></i>
                              </button>
                              <button
                                className="h-[36px] w-[36px] bg-danger rounded-full"
                                title="Delete Sub Category"
                                onClick={() => {
                                  deleteSubCategory(item?._id);
                                }}
                              >
                                <i className="fa fa-trash text-white"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <td colSpan={4} className="text-center">
                          <p className="text-center w-full mt-10">
                            No results found
                          </p>
                        </td>
                      )
                    ) : (
                      <td colSpan={4} className="text-center">
                        <p className="text-center w-full mt-10">Loading ...</p>
                      </td>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          )}

          {!["tiffin"].includes(CategoryName?.toLowerCase()) && (

          <div className="mt-4">
            <div className="flex justify-between items-center mt-0 ">
              <h2 className="text-lg font-medium">View Products</h2>
              <div className="">
                <button
                  className="border py-2 px-2 rounded-md text-sm !outline-none"
                  onClick={() => {
                    navigate(`/admin-panel/product/add/${id}`);
                  }}
                >
                  Add Product
                </button>
              </div>
            </div>

            {/* Products Listing */}
            <div className="mt-6">
              <div className="flex gap-4 justify-between flex-wrap mt-5">
                <table className="w-full text-center">
                  <thead>
                    <tr className="border-b">
                      <td className="font-medium py-4 cursor-pointer">
                        Product Name{" "}
                      </td>
                      <td className="font-medium py-4 cursor-pointer">
                        Created At{" "}
                      </td>
                      <td className="font-medium py-4 cursor-pointer">
                        Status{" "}
                      </td>
                      <td className="font-medium py-4 cursor-pointer">
                        Actions{" "}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {!loading ? (
                      data?.length > 0 ? (
                        data?.map((item) => (
                          <tr key={item._id} className="border-b">
                            <td className="py-3 text-sm">{item.name}</td>
                            <td className="py-3 text-sm">
                              {formatDate(item.createdAt)}
                            </td>
                            <td className="py-3 text-sm">{item.status}</td>
                            <td className="py-3 text-sm flex justify-center gap-x-3">
                              <button
                                className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                                title="View Category"
                                onClick={() => {
                                  navigate(
                                    `/admin-panel/product/view/${item._id}`,
                                    { state: { data: item } }
                                  );
                                }}
                              >
                                <i className="fa fa-eye text-white"></i>
                              </button>
                              <button
                                className="h-[36px] w-[36px] bg-[#ff8a00] rounded-full"
                                title="Edit Product"
                                onClick={() => {
                                  navigate(
                                    `/admin-panel/product/edit/${item._id}`,
                                    { state: { data: item } }
                                  );
                                }}
                              >
                                <i className="fa fa-edit text-white"></i>
                              </button>
                              <button
                                className="h-[36px] w-[36px] bg-danger rounded-full"
                                title="Delete Product"
                                onClick={() => {
                                  deleteProduct(item?._id);
                                }}
                              >
                                <i className="fa fa-trash text-white"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <td colSpan={4} className="text-center">
                          <p className="text-center w-full mt-10">
                            No results found
                          </p>
                        </td>
                      )
                    ) : (
                      <td colSpan={4} className="text-center">
                        <p className="text-center w-full mt-10">Loading ...</p>
                      </td>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          )}

          {["water", "oxygen"].includes(CategoryName?.toLowerCase()) && (
            <div className="mt-4">
              <div className="flex justify-between items-center mt-0 ">
                <h2 className="text-lg font-medium">View Accessories</h2>
                <div className="">
                  <button
                    className="border py-2 px-2 rounded-md text-sm !outline-none"
                    onClick={() => {
                      navigate(`/admin-panel/accessory/add/${id}`, {
                        state: { data: CategoryName },
                      });
                    }}
                  >
                    Add Accessory
                  </button>

                  
                </div>
              </div>

              {/* Accessories Listing */}
              <div className="mt-6">
                <div className="flex gap-4 justify-between flex-wrap mt-5">
                  <table className="w-full text-center">
                    <thead>
                      <tr className="border-b">
                        <td className="font-medium py-4 cursor-pointer">
                          Name{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Created At{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Status{" "}
                        </td>
                        <td className="font-medium py-4 cursor-pointer">
                          Actions{" "}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading ? (
                        accessories?.length > 0 ? (
                          accessories?.map((item) => (
                            <tr key={item._id} className="border-b">
                              <td className="py-3 text-sm">{item.name}</td>
                              <td className="py-3 text-sm">
                                {formatDate(item.createdAt)}
                              </td>
                              <td className="py-3 text-sm">{item.status}</td>
                              <td className="py-3 text-sm flex justify-center gap-x-3">
                                <button
                                  className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                                  title="View Accessory"
                                  onClick={() => {
                                    navigate(
                                      `/admin-panel/accessory/view/${item._id}`,
                                      { state: { data: item } }
                                    );
                                  }}
                                >
                                  <i className="fa fa-eye text-white"></i>
                                </button>
                                <button
                                  className="h-[36px] w-[36px] bg-[#ff8a00] rounded-full"
                                  title="Edit Accessory"
                                  onClick={() => {
                                    navigate(
                                      `/admin-panel/accessory/edit/${item._id}`,
                                      {
                                        state: {
                                          data: item,
                                          name: CategoryName,
                                        },
                                      }
                                    );
                                  }}
                                >
                                  <i className="fa fa-edit text-white"></i>
                                </button>
                                <button
                                  className="h-[36px] w-[36px] bg-danger rounded-full"
                                  title="Delete Accessory"
                                  onClick={() => {
                                    deleteAccessory(item._id);
                                  }}
                                >
                                  <i className="fa fa-trash text-white"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <td colSpan={4} className="text-center">
                            <p className="text-center w-full mt-10">
                              No results found
                            </p>
                          </td>
                        )
                      ) : (
                        <td colSpan={4} className="text-center">
                          <p className="text-center w-full mt-10">
                            Loading ...
                          </p>
                        </td>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </Layout>
    </div>
  );
}
